function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.70781 17.7376C14.6059 17.7376 18.5766 13.7669 18.5766 8.86882C18.5766 3.97071 14.6059 0 9.70781 0C4.8097 0 0.838989 3.97071 0.838989 8.86882C0.838989 13.7669 4.8097 17.7376 9.70781 17.7376Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.70779 15.9638C13.6263 15.9638 16.8028 12.7872 16.8028 8.86874C16.8028 4.95025 13.6263 1.77368 9.70779 1.77368C5.7893 1.77368 2.61273 4.95025 2.61273 8.86874C2.61273 12.7872 5.7893 15.9638 9.70779 15.9638Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.70789 1.47815C5.62084 1.47815 2.3172 4.78179 2.3172 8.86884C2.3172 12.9559 5.62084 16.2595 9.70789 16.2595C13.7949 16.2595 17.0986 12.9559 17.0986 8.86884C17.0986 4.78179 13.7949 1.47815 9.70789 1.47815ZM13.4032 11.5221L12.3611 12.5642L9.70789 9.91092L7.05463 12.5642L6.01254 11.5221L8.6658 8.86884L6.01254 6.21558L7.05463 5.17349L9.70789 7.82675L12.3611 5.17349L13.4032 6.21558L10.75 8.86884L13.4032 11.5221Z"
});

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.9189bda2.svg";
export { ForwardRef as ReactComponent };